// extracted by mini-css-extract-plugin
export var preview = "article-module--preview--2_NCB";
export var title = "article-module--title--5fYRG";
export var metadata = "article-module--metadata--EqSTD";
export var tags = "article-module--tags--BislX";